var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizantalLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 32,
    viewBox: "0 0 475 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    y1: 15.5,
    x2: 202,
    y2: 15.5,
    stroke: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.886 24.16C226.806 24.16 223.806 21.12 223.806 17C223.806 12.88 226.806 9.84 230.886 9.84C234.946 9.84 237.946 12.88 237.946 17C237.946 21.12 234.946 24.16 230.886 24.16ZM230.866 21.86C233.426 21.86 235.286 19.8 235.286 17C235.286 14.2 233.426 12.12 230.866 12.12C228.326 12.12 226.466 14.2 226.466 17C226.466 19.8 228.326 21.86 230.866 21.86ZM250.192 20.26L250.532 24H247.912L247.572 20.56C247.472 19.5 246.732 18.74 245.692 18.74H242.672V24H240.012V10H245.752C248.672 10 250.392 11.78 250.392 14.32C250.392 15.76 249.672 16.74 248.512 17.34C249.472 17.94 250.092 18.98 250.192 20.26ZM242.672 12.22V16.46H245.632C247.192 16.46 247.832 15.44 247.832 14.32C247.832 13.2 247.192 12.22 245.632 12.22H242.672Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273,
    y1: 15.5,
    x2: 475,
    y2: 15.5,
    stroke: "#D4D4D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizantalLine);
export default __webpack_public_path__ + "static/media/HorizantalLine.eab88ae121d9a361fe80b59212fbe29c.svg";
export { ForwardRef as ReactComponent };